export default function Illutration(props) {
  return (
    <>
      <svg viewBox="0 0 641 640" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M618.971 248.168C612.052 162.855 608.592 120.199 592.488 92.6007C546.378 13.5793 412.319 -5.21524 327.65 1.99198C214.298 11.6382 84.6249 76.8001 27.5449 202.611C-24.2988 316.883 -0.393424 446.232 77.7237 530.846C220.925 685.957 516.316 658.263 588.475 556.483C617.272 515.863 619.348 450.984 622.399 355.68C623.865 309.804 621.004 273.245 618.971 248.168Z"
          fill="#F4F7FA"
        />
        <path
          d="M564.653 52.769C557.325 46.7058 546.208 43.4037 536.811 42.7368C470.199 38.0165 460.477 177.253 470.688 208.371C480.898 239.488 474.282 249.705 421.82 265.985C369.357 282.265 394.525 313.611 400.92 331.942C407.314 350.273 419.977 365.758 381.732 383.973C343.488 402.187 356.779 413.473 356.779 413.473C356.779 413.473 427.307 485.616 423.411 462.519C419.515 439.422 426.574 404.546 489.809 401.895C517.046 400.753 558.755 387.761 567.99 358.597C570.141 351.805 571.637 341.433 570.002 334.403C567.732 324.652 561.333 316.97 557.779 307.792C549.499 286.406 570.269 270.744 582.221 256.448C588.463 248.985 594.699 241.333 599.477 232.824C609.399 215.158 605.684 196.212 594.88 179.928C589.698 172.12 582.5 163.835 580.239 154.52C577.812 144.515 579.929 130.845 580.504 120.553C580.956 112.48 581.726 104.439 581.271 96.3457C580.431 81.2964 576.905 62.9061 564.653 52.769Z"
          fill="url(#paint0_linear_1_7)"
        />
        <g opacity="0.8">
          <g opacity="0.8">
            <path
              opacity="0.8"
              d="M351.233 453.964C350.776 454.129 350.258 453.935 350.027 453.494C349.776 453.012 349.961 452.416 350.443 452.165C350.74 452.01 380.432 436.392 413.554 410.669C444.075 386.966 483.836 349.594 499.933 306.148C513.379 269.863 525.64 209.876 533.576 141.571C540.692 80.3213 541.816 35.0226 538.792 26.6142C538.607 26.1026 538.874 25.5386 539.386 25.3536C539.897 25.1686 540.461 25.4358 540.646 25.9473C544.184 35.7853 541.939 86.6721 535.536 141.8C527.584 210.255 515.282 270.406 501.783 306.833C485.519 350.725 445.47 388.385 414.737 412.246C381.478 438.07 351.655 453.754 351.359 453.91C351.315 453.93 351.274 453.948 351.233 453.964Z"
              fill="white"
            />
          </g>
          <g opacity="0.8">
            <path
              opacity="0.8"
              d="M533.468 153.444C532.959 153.627 532.441 153.486 532.253 152.976C532.007 152.303 507.174 85.4942 475.153 70.4106C474.659 70.18 474.461 69.6228 474.691 69.1295C474.924 68.6362 475.516 68.4421 476.007 68.6728C508.761 84.1012 533.078 149.507 534.099 152.291C534.286 152.803 533.984 153.259 533.473 153.442C533.471 153.444 533.468 153.444 533.468 153.444Z"
              fill="white"
            />
          </g>
          <g opacity="0.8">
            <path
              opacity="0.8"
              d="M521.357 230.921C520.978 231.058 520.535 230.951 520.263 230.62C519.918 230.2 519.978 229.579 520.398 229.234C520.581 229.083 538.864 214.086 561.422 201.501C591.902 184.497 615.261 179.749 630.849 187.393C631.338 187.632 631.539 188.222 631.299 188.71C631.059 189.199 630.47 189.4 629.982 189.16C594.114 171.576 522.369 230.159 521.649 230.752C521.56 230.828 521.46 230.885 521.357 230.921Z"
              fill="white"
            />
          </g>
          <g opacity="0.8">
            <path
              opacity="0.8"
              d="M441.76 389.287C441.659 389.324 441.554 389.342 441.442 389.344C440.899 389.353 440.451 388.92 440.442 388.374C440.438 388.088 439.931 359.424 433.931 329.22C428.43 301.529 417.071 266.842 394.198 258.849C393.684 258.669 393.412 258.107 393.593 257.596C393.771 257.082 394.335 256.81 394.847 256.99C413.92 263.654 427.72 287.836 435.868 328.864C441.899 359.239 442.406 388.056 442.411 388.344C442.42 388.778 442.146 389.148 441.76 389.287Z"
              fill="white"
            />
          </g>
          <g opacity="0.8">
            <path
              opacity="0.8"
              d="M482.463 342.976C482.063 343.12 481.602 342.992 481.337 342.633C481.013 342.195 481.106 341.578 481.542 341.256C484.714 338.911 559.536 283.905 588.715 289.157C589.251 289.253 589.605 289.767 589.509 290.301C589.413 290.838 588.902 291.194 588.365 291.096C560.014 285.992 483.484 342.27 482.714 342.839C482.636 342.901 482.55 342.944 482.463 342.976Z"
              fill="white"
            />
          </g>
        </g>
        <path
          d="M623.117 257.849C618.273 249.665 608.929 242.795 600.312 238.988C539.225 212.007 482.964 339.741 482.042 372.477C481.119 405.214 471.436 412.59 416.562 410.158C361.686 407.726 374.762 445.74 374.577 465.153C374.392 484.566 381.067 503.422 338.916 507.622C296.764 511.822 305.451 526.937 305.451 526.937C305.451 526.937 347.409 618.69 351.558 595.637C355.707 572.583 374.15 542.153 434.551 561.057C460.566 569.199 504.211 571.087 522.771 546.769C527.094 541.105 532.01 531.852 532.849 524.683C534.011 514.74 530.59 505.345 530.35 495.507C529.793 472.579 554.639 464.87 570.723 455.463C579.12 450.553 587.579 445.461 594.955 439.071C610.269 425.805 613.185 406.721 608.529 387.741C606.296 378.641 602.324 368.408 603.35 358.878C604.45 348.643 611.068 336.494 615.092 327.003C618.248 319.561 621.694 312.253 624.005 304.484C628.31 290.031 631.217 271.533 623.117 257.849Z"
          fill="url(#paint1_linear_1_7)"
        />
        <g opacity="0.8">
          <g opacity="0.8">
            <path
              opacity="0.8"
              d="M286.53 563.16C286.046 563.16 285.623 562.802 285.555 562.309C285.482 561.77 285.859 561.272 286.398 561.199C286.729 561.153 319.954 556.503 359.826 543.505C396.566 531.529 446.628 509.814 476.478 474.378C501.409 444.782 533.245 392.484 563.823 330.894C591.243 275.666 607.628 233.418 607.628 224.482C607.628 223.939 608.069 223.498 608.613 223.498C609.156 223.498 609.597 223.939 609.597 224.482C609.597 234.937 590.266 282.062 565.586 331.771C534.94 393.496 503.01 445.938 477.983 475.648C447.827 511.447 397.397 533.333 360.402 545.389C320.367 558.435 286.996 563.103 286.663 563.149C286.621 563.158 286.576 563.16 286.53 563.16Z"
              fill="white"
            />
          </g>
          <g opacity="0.8">
            <path
              opacity="0.8"
              d="M559.706 342.235C559.165 342.235 558.724 341.824 558.722 341.283C558.718 340.566 557.957 269.245 532.928 244.216C532.542 243.832 532.542 243.213 532.928 242.83C533.312 242.446 533.935 242.448 534.321 242.832C559.923 268.434 560.672 338.305 560.693 341.269C560.697 341.812 560.259 342.235 559.713 342.235C559.709 342.235 559.706 342.235 559.706 342.235Z"
              fill="white"
            />
          </g>
          <g opacity="0.8">
            <path
              opacity="0.8"
              d="M522.094 410.843C521.69 410.843 521.311 410.592 521.167 410.19C520.984 409.678 521.249 409.114 521.763 408.929C521.985 408.849 544.264 400.923 569.752 396.714C604.187 391.025 627.775 394.464 639.86 406.931C640.239 407.321 640.228 407.945 639.837 408.324C639.447 408.703 638.824 408.692 638.444 408.301C610.643 379.618 523.307 410.468 522.428 410.783C522.316 410.824 522.204 410.843 522.094 410.843Z"
              fill="white"
            />
          </g>
          <g opacity="0.8">
            <path
              opacity="0.8"
              d="M393.605 532.932C393.5 532.932 393.393 532.914 393.285 532.879C392.771 532.703 392.495 532.144 392.673 531.628C392.765 531.356 401.988 504.213 406.562 473.76C410.755 445.84 411.803 409.356 392.984 394.094C392.561 393.752 392.497 393.131 392.84 392.708C393.183 392.286 393.804 392.22 394.226 392.564C409.919 405.289 414.724 432.716 408.506 474.077C403.904 504.701 394.63 531.991 394.537 532.265C394.397 532.674 394.014 532.932 393.605 532.932Z"
              fill="white"
            />
          </g>
          <g opacity="0.8">
            <path
              opacity="0.8"
              d="M447.574 503.126C447.149 503.126 446.759 502.85 446.631 502.425C446.474 501.904 446.77 501.354 447.291 501.198C451.068 500.066 540.09 473.621 565.77 488.437C566.24 488.709 566.402 489.312 566.13 489.782C565.859 490.253 565.256 490.415 564.785 490.143C539.832 475.747 448.773 502.811 447.857 503.085C447.764 503.112 447.668 503.126 447.574 503.126Z"
              fill="white"
            />
          </g>
        </g>
        <path
          d="M418.345 27.7401L417.641 32.7779C415.305 32.8852 413.008 33.1866 410.772 33.689L408.868 28.9893C408.349 27.7081 406.881 27.0984 405.591 27.6305L397.513 30.9578C396.221 31.4899 395.59 32.9651 396.107 34.2485L398.02 39.0077C396.063 40.2545 394.213 41.6659 392.492 43.2279L388.436 40.081C387.34 39.2315 385.75 39.4416 384.885 40.5514L379.459 47.4938C378.589 48.6059 378.774 50.1999 379.87 51.0517L383.942 54.2168C382.857 56.2539 381.946 58.4051 381.21 60.6499L376.042 59.9717C374.654 59.789 373.361 60.7732 373.156 62.1708L371.856 70.9264C371.649 72.3285 372.608 73.6165 373.998 73.7992L379.182 74.4797C379.244 76.8433 379.502 79.1681 379.961 81.4312L375.097 83.4591C373.786 84.0049 373.142 85.5144 373.658 86.8275L376.899 95.0624C377.417 96.3823 378.904 97.0058 380.219 96.4554L385.086 94.4184C386.31 96.4097 387.705 98.2869 389.253 100.032L386.011 104.243C385.134 105.382 385.321 107.013 386.431 107.885L393.382 113.338C394.494 114.211 396.109 113.992 396.984 112.848L400.187 108.664C402.234 109.753 404.399 110.66 406.657 111.384L405.929 116.604C405.73 118.034 406.705 119.342 408.107 119.525L416.883 120.676C418.288 120.861 419.583 119.849 419.779 118.42L420.487 113.238C422.873 113.135 425.219 112.827 427.5 112.313L429.425 117.1C429.96 118.429 431.455 119.057 432.766 118.502L440.951 115.033C442.259 114.478 442.883 112.955 442.346 111.63L440.421 106.878C442.419 105.588 444.301 104.124 446.046 102.505L450.047 105.615C451.166 106.485 452.769 106.266 453.627 105.126L458.987 98.0197C459.844 96.8847 459.631 95.2656 458.514 94.4001L454.55 91.3263C455.63 89.2322 456.528 87.0193 457.24 84.7151L462.196 85.3659C463.586 85.5486 464.861 84.5553 465.041 83.1485L466.167 74.3701C466.347 72.9703 465.368 71.6868 463.979 71.5041L459.037 70.8556C458.935 68.4623 458.633 66.1147 458.126 63.8333L462.709 61.9151C463.997 61.3761 464.607 59.8872 464.073 58.59L460.725 50.4968C460.191 49.2042 458.715 48.5922 457.427 49.1288L452.817 51.0517C451.561 49.0809 450.14 47.222 448.562 45.5024L451.609 41.5266C452.456 40.419 452.248 38.8364 451.147 37.9892L444.262 32.6979C443.161 31.853 441.583 32.0608 440.734 33.1638L437.669 37.1442C435.637 36.0892 433.49 35.2122 431.25 34.518L431.933 29.5191C432.12 28.1443 431.158 26.8814 429.781 26.701L421.179 25.5729C419.809 25.3971 418.537 26.3631 418.345 27.7401ZM388.016 68.5468C390.503 51.2458 406.381 39.1173 423.497 41.3621C440.613 43.607 452.634 59.3962 450.334 76.72C448.021 94.1512 432.108 106.517 414.805 104.25C397.502 101.98 385.515 85.9529 388.016 68.5468Z"
          fill="#D8DEE8"
        />
        <path
          d="M286.436 25.0085L285.349 32.7981C281.738 32.9625 278.185 33.4284 274.727 34.2048L271.784 26.9382C270.98 24.956 268.712 24.0151 266.719 24.8372L254.229 29.9823C252.231 30.8067 251.256 33.0835 252.055 35.0726L255.015 42.4305C251.989 44.3579 249.128 46.5388 246.467 48.9572L240.187 44.0908C238.495 42.7776 236.035 43.1042 234.697 44.817L226.307 55.5502C224.962 57.2697 225.247 59.7338 226.942 61.0515L233.238 65.9477C231.562 69.0968 230.15 72.4241 229.013 75.893L221.023 74.8448C218.878 74.5639 216.88 76.0848 216.558 78.2452L214.551 91.785C214.229 93.9544 215.713 95.9435 217.864 96.2244L225.878 97.2749C225.974 100.929 226.371 104.526 227.083 108.024L219.563 111.16C217.535 112.004 216.54 114.336 217.339 116.369L222.349 129.1C223.151 131.139 225.451 132.105 227.483 131.253L235.008 128.104C236.899 131.183 239.057 134.085 241.452 136.782L236.44 143.293C235.083 145.056 235.373 147.577 237.09 148.924L247.84 157.356C249.559 158.705 252.055 158.365 253.409 156.597L258.363 150.13C261.526 151.816 264.876 153.218 268.367 154.337L267.239 162.409C266.931 164.62 268.438 166.643 270.61 166.926L284.179 168.705C286.349 168.991 288.354 167.427 288.655 165.216L289.752 157.205C293.442 157.047 297.068 156.57 300.594 155.775L303.57 163.177C304.397 165.232 306.71 166.203 308.736 165.344L321.392 159.982C323.413 159.126 324.379 156.769 323.547 154.718L320.57 147.369C323.659 145.376 326.569 143.11 329.268 140.607L335.452 145.417C337.181 146.762 339.659 146.421 340.988 144.663L349.275 133.676C350.597 131.923 350.271 129.417 348.544 128.079L342.415 123.329C344.087 120.089 345.473 116.668 346.574 113.107L354.238 114.112C356.389 114.395 358.36 112.859 358.638 110.685L360.378 97.1105C360.657 94.9433 359.141 92.9611 356.996 92.6802L349.355 91.6776C349.198 87.9781 348.732 84.3471 347.946 80.8211L355.035 77.8546C357.028 77.0211 357.971 74.7192 357.14 72.7141L351.963 60.1997C351.136 58.2015 348.855 57.2561 346.866 58.085L339.739 61.056C337.798 58.0074 335.598 55.1345 333.162 52.4786L337.871 46.331C339.181 44.6206 338.862 42.1725 337.156 40.8617L326.509 32.6816C324.808 31.3753 322.367 31.6973 321.054 33.4032L316.313 39.5577C313.168 37.9272 309.85 36.5707 306.388 35.4951L307.445 27.7649C307.735 25.6388 306.246 23.6885 304.12 23.4099L290.818 21.6652C288.697 21.3866 286.733 22.8824 286.436 25.0085ZM239.541 88.1037C243.384 61.3529 267.936 42.5995 294.399 46.0707C320.862 49.5418 339.449 73.9542 335.895 100.741C332.319 127.691 307.717 146.814 280.964 143.304C254.209 139.797 235.672 115.014 239.541 88.1037Z"
          fill="#D8DEE8"
        />
        <path
          d="M273.709 100.438L215.531 584.012C214.658 591.262 219.655 597.762 226.657 598.456L468.98 625.06C483.824 625.983 491.951 618.399 492.869 610.689L553.951 96.5693C554.862 88.9031 547.579 81.9585 532.671 81.9585L288.144 87.1081C281.062 87.2292 274.577 93.2261 273.709 100.438Z"
          fill="url(#paint2_linear_1_7)"
        />
        <path
          d="M262.802 99.607L204.304 585.599C203.427 592.887 208.442 599.42 215.466 600.119L466.687 625.132C474.563 625.915 481.782 620.217 482.702 612.469L544.126 95.6929C545.042 87.9855 539.257 81.7922 531.294 81.927L277.287 86.2134C270.185 86.3299 263.674 92.3587 262.802 99.607Z"
          fill="url(#paint3_linear_1_7)"
        />
        <path
          d="M267.57 126.412L213.349 577.023C212.529 583.831 217.226 589.924 223.801 590.563L460.066 613.53C467.388 614.243 474.097 608.924 474.956 601.71L531.72 124.329C532.575 117.154 527.203 111.347 519.807 111.427L281.116 113.968C274.473 114.037 268.385 119.639 267.57 126.412Z"
          fill={props.primaryColor || "#E42424"}
        />
        <path
          d="M394.267 99.2709C393.957 101.858 395.813 103.93 398.417 103.895C401.022 103.863 403.388 101.735 403.699 99.143C404.009 96.5511 402.146 94.4798 399.54 94.5186C396.935 94.5574 394.576 96.6858 394.267 99.2709Z"
          fill="url(#paint4_linear_1_7)"
        />
        <path
          d="M308.417 428.892C356.785 339.466 429.042 312.697 450.797 220.533C462.555 170.715 454.544 123.033 441.05 83.4477L531.298 81.9245C539.261 81.7898 545.045 87.9854 544.13 95.6904L482.706 612.466C481.786 620.217 474.567 625.915 466.691 625.129L269.207 605.467C267.743 525.338 286.855 468.754 308.417 428.892Z"
          fill="white"
          fill-opacity="0.19"
        />
        <path
          d="M24.291 150.891C24.291 103.373 65.7417 64.8592 115.484 64.8638C163.756 64.8683 201.852 101.357 201.852 146.361C201.852 191.365 163.756 229.796 115.484 232.265C65.7394 234.809 24.291 198.41 24.291 150.891Z"
          fill="url(#paint5_linear_1_7)"
        />
        <path
          d="M29.6533 147.102C29.6533 99.5841 69.9051 61.0701 118.207 61.0747C165.081 61.0793 202.076 97.5676 202.076 142.572C202.076 187.576 165.081 226.007 118.207 228.476C69.9028 231.02 29.6533 194.619 29.6533 147.102Z"
          fill="url(#paint6_linear_1_7)"
        />
        <g opacity="0.5">
          <path
            opacity="0.5"
            d="M43.4326 146.739C43.4326 106.816 77.249 74.457 117.832 74.4639C157.214 74.4684 188.297 105.124 188.297 142.935C188.297 180.745 157.216 213.034 117.832 215.108C77.249 217.245 43.4326 186.662 43.4326 146.739Z"
            fill="white"
          />
        </g>
        <path
          opacity="0.5"
          d="M115.039 80.5978C154.421 80.6023 185.504 111.258 185.504 149.069C185.504 158.059 183.73 166.731 180.521 174.764C185.49 165.091 188.299 154.264 188.299 142.935C188.299 105.124 157.219 74.4684 117.835 74.4639C86.5348 74.4616 59.2771 93.7174 48.4365 120.838C60.7112 96.9944 86.1557 80.5955 115.039 80.5978Z"
          fill="white"
        />
        <path
          d="M84.1836 136.968V171.812C84.1836 181.885 92.6583 189.832 103.081 189.561L128.925 188.887C139.222 188.618 147.544 180.321 147.544 170.353V135.876L84.1836 136.968ZM107.984 172.99L112.786 158.437C110.729 157.375 109.336 155.283 109.336 152.846C109.336 149.27 112.337 146.313 116.032 146.244C119.722 146.173 122.711 149.01 122.711 152.579C122.711 155.011 121.323 157.156 119.272 158.302L124.056 172.616L107.984 172.99Z"
          fill="white"
        />
        <path
          d="M140.197 132.855C137.454 132.901 135.23 130.779 135.23 128.114C135.23 117.872 126.632 109.651 116.029 109.788C105.39 109.925 96.7048 118.422 96.7048 128.728C96.7048 131.409 94.4508 133.62 91.667 133.668C88.8809 133.714 86.6201 131.576 86.6201 128.89C86.6201 113.204 99.8494 100.292 116.031 100.112C132.127 99.9314 145.155 112.423 145.155 127.959C145.155 130.617 142.937 132.809 140.197 132.855Z"
          fill="white"
        />
        <path
          d="M200.056 331.594C200.056 331.594 198.298 325.004 199.544 323.318C200.789 321.633 208.405 314.896 207.674 317.093C206.941 319.29 205.843 320.754 205.843 320.754C205.843 320.754 209.944 322.658 207.307 325.513C204.671 328.37 203.79 329.027 203.644 331.592C203.5 334.157 201.814 335.036 200.056 331.594Z"
          fill="url(#paint7_linear_1_7)"
        />
        <path
          d="M126.899 616.086C126.899 616.086 125.967 621.786 126.086 623.814C126.204 625.842 148.717 626.878 148.943 625.36C149.169 623.841 145.223 621.423 142.444 620.571C139.664 619.717 131.53 617.442 131.53 617.442L126.899 616.086Z"
          fill="url(#paint8_linear_1_7)"
        />
        <path
          d="M132.363 610.404L131.645 617.492C131.645 617.492 129.031 619.221 126.727 617.888L125.573 610.173L132.363 610.404Z"
          fill="url(#paint9_linear_1_7)"
        />
        <path
          d="M86.7317 625.326C86.7317 625.326 85.7999 631.026 85.9187 633.054C86.0374 635.081 108.55 636.118 108.776 634.6C109.004 633.081 105.056 630.663 102.277 629.811C99.4973 628.959 91.3629 626.682 91.3629 626.682L86.7317 625.326Z"
          fill="url(#paint10_linear_1_7)"
        />
        <path
          d="M92.1975 619.644L91.4805 626.732C91.4805 626.732 88.8657 628.461 86.5615 627.127L85.4082 619.413L92.1975 619.644Z"
          fill="url(#paint11_linear_1_7)"
        />
        <path
          d="M127.278 423.368C129.879 428.643 132.483 433.919 135.084 439.194C137.176 469.299 138.217 502.038 137.548 537.049C137.05 563.096 135.659 587.771 133.659 610.932C130.13 610.77 126.602 610.608 123.074 610.445C117.972 600.32 111.95 584.98 111.395 566.044C110.818 546.293 116.805 543.669 116.426 524.758C115.933 500.245 105.654 493.705 100.178 464.221C98.0838 452.944 96.6748 438.216 98.3488 420.349C107.993 421.356 117.634 422.363 127.278 423.368Z"
          fill="url(#paint12_linear_1_7)"
        />
        <path
          opacity="0.3"
          d="M99.3507 422.349C104.557 422.893 109.764 423.436 114.973 423.98C124.348 440.292 126.965 457.269 125.318 464.78C122.991 475.405 116.834 478.808 117.175 489.475C117.51 500.03 123.729 502.768 127.673 515.207C130.404 523.821 129.682 531.741 128.129 547.229C125.001 578.426 117.467 587.967 123.777 598.195C125.569 601.103 128.801 604.562 135.131 607.204C134.976 609.118 134.823 611.036 134.661 612.93C131.132 612.77 127.604 612.605 124.076 612.445C118.974 602.32 112.952 586.98 112.397 568.044C111.82 548.293 117.807 545.669 117.428 526.758C116.935 502.245 106.656 495.707 101.18 466.223C99.0858 454.946 97.6745 440.219 99.3507 422.349Z"
          fill="url(#paint13_linear_1_7)"
        />
        <path
          d="M114.277 434.866C109.392 461.503 105.078 490.01 101.712 520.243C97.6473 556.747 95.4778 591.162 94.626 623.113C90.7529 623.222 86.8821 623.332 83.0091 623.442C67.7496 593.254 66.8179 572.788 69.0171 559.463C69.8643 554.329 72.1685 544.26 72.6938 529.211C73.0592 518.722 72.39 510.738 71.5542 501.142C69.7227 480.103 67.4984 475.511 67.1787 459.418C66.8773 444.314 66.8156 436.673 71.1272 432.213C82.4861 420.459 112.037 433.825 114.277 434.866Z"
          fill="url(#paint14_linear_1_7)"
        />
        <path
          d="M198.031 330.579C200.607 330.398 203.18 330.22 205.756 330.04C211.831 354.591 207.474 378.405 193.763 387.163C172.34 400.847 132.524 375.067 123.896 346.994C120.11 334.671 120.971 316.89 128.541 313.435C130.642 312.476 133.903 312.328 140.967 316.292C162.061 328.135 162.616 350.52 173.34 352.415C178.104 353.26 185.804 350.22 198.031 330.579Z"
          fill="url(#paint15_linear_1_7)"
        />
        <path
          d="M139.048 446.595C142.759 440.438 138.098 434.501 137.038 422.838C135.837 409.618 140.93 407.416 145.965 385.509C149.315 370.94 152.528 356.952 148.692 340.578C146.853 332.732 143.734 319.423 132.718 312.994C127.034 309.676 119.271 310.009 103.982 310.809C85.0736 311.797 75.6215 312.291 68.5696 316.004C67.5374 316.547 46.0893 328.215 44.6117 347.233C43.1091 366.589 64.1872 369.19 66.9984 395.002C68.2613 406.59 66.0119 424.411 64.5526 435.969C63.1527 447.068 62.1868 449.909 64.3791 453.27C69.6589 461.37 85.8203 459.061 118.143 454.446C130.822 452.633 136.278 451.19 139.048 446.595Z"
          fill="url(#paint16_linear_1_7)"
        />
        <path
          d="M89.8659 390.849C88.498 395.88 83.5836 399.636 80.1627 411.875C79.425 414.517 74.1612 433.332 80.9871 437.963C84.9286 440.637 88.4683 435.57 98.0368 434.907C114.616 433.761 122.515 447.696 133.347 443.889C135.226 443.227 137.706 441.82 140.184 438.586C140.677 441.5 140.593 444.033 139.049 446.598C136.281 451.192 130.823 452.636 118.144 454.446C85.8216 459.062 69.6601 461.371 64.3803 453.27C62.1902 449.911 63.154 447.068 64.5538 435.969C66.0131 424.41 68.2625 406.588 66.9996 395.003C64.1885 369.191 43.108 366.59 44.6129 347.233C45.0148 342.058 46.9171 337.452 49.4634 333.44C76.2028 344.26 94.1615 375.039 89.8659 390.849Z"
          fill="url(#paint17_linear_1_7)"
        />
        <path
          d="M56.0947 428.921L61.4453 432.338C62.4068 431.228 64.631 428.99 68.1022 428.227C72.0141 427.366 76.5061 428.602 76.6088 429.849C76.6933 430.849 73.9575 431.858 73.535 432.013C70.121 433.274 67.5884 432.226 66.209 433.598C65.7203 434.082 65.1129 434.987 63.713 435.823C63.3453 436.042 62.9617 436.236 62.7584 436.316C60.4794 437.202 56.572 433.235 56.2363 432.888L56.0947 428.921Z"
          fill="url(#paint18_linear_1_7)"
        />
        <path
          d="M71.8996 358.754C75.7704 349.485 78.4514 335.292 72.338 314.216C32.0589 330.087 11.5174 367.713 19.5376 397.537C26.1488 422.126 50.2048 434.101 55.5714 436.622C56.8206 433.779 58.0697 430.938 59.3166 428.097C53.0982 421.173 46.0897 410.933 47.0808 399.248C48.4556 383.048 64.0644 377.519 71.8996 358.754Z"
          fill="url(#paint19_linear_1_7)"
        />
        <path
          d="M102.991 291.74C102.991 291.74 102.673 298.785 100.485 304.062C98.5078 308.831 88.1126 311.829 86.0048 312.893C83.8969 313.957 89.9532 317.07 96.0346 317.68C102.116 318.292 119.481 316.91 122.612 314.606C125.743 312.302 120.095 312.475 115.756 310.881C111.415 309.287 108.905 300.799 109.673 296.946C110.44 293.092 102.991 291.74 102.991 291.74Z"
          fill="url(#paint20_linear_1_7)"
        />
        <path
          d="M112.609 289.185C115.765 286.083 116.206 285.723 116.549 284.652C117.928 280.351 114.592 274.46 110.216 273.009C109.988 272.934 107.053 271.996 105.934 273.268C104.982 274.348 106.382 275.841 105.717 277.926C105.094 279.876 103.404 280.023 100.268 282.58C97.6857 284.686 96.0825 285.997 95.7126 287.84C94.9498 291.637 99.5468 297.141 103.616 296.992C105.08 296.938 105.48 296.191 112.609 289.185Z"
          fill="url(#paint21_linear_1_7)"
        />
        <path
          d="M104.017 297.579C104.017 297.579 107.371 301.377 112.48 300.121C117.054 298.997 115.887 288.497 112.539 286.821C111.422 286.261 109.392 286.307 107.867 287.042C106.965 287.476 106.714 287.928 105.227 288.609C103.857 289.237 103.421 289.15 103.053 289.593C102.592 290.146 102.393 291.338 103.838 294.211C102.797 293.473 101.676 293.318 100.988 293.807C100.879 293.884 100.6 294.158 100.479 294.517C100.043 295.816 101.395 297.138 104.017 297.579Z"
          fill="url(#paint22_linear_1_7)"
        />
        <path
          d="M486.589 155.41L487.77 161.783L463.465 161.84L252.546 162.341C247.12 162.354 242.13 166.839 241.386 172.359L191.036 508.863C190.287 514.433 198.955 522.935 204.349 523.35L297.922 530.542V530.428L437.892 541.165C437.895 541.165 437.897 541.165 437.899 541.165L438.237 541.307C444.214 541.768 449.697 537.432 450.473 531.549C450.473 531.547 450.473 531.574 450.475 531.572L497.628 172.295C498.396 166.467 492.6 155.394 486.589 155.41Z"
          fill="url(#paint23_linear_1_7)"
        />
        <path
          d="M445.704 524.548C444.932 530.433 439.452 534.831 433.475 534.372L199.345 516.395C193.954 515.982 190.202 511.131 190.951 505.561L236.722 165.479C237.464 159.959 242.454 155.474 247.875 155.458L483.327 154.81C489.336 154.794 493.597 159.505 492.834 165.333L445.704 524.548Z"
          fill="url(#paint24_linear_1_7)"
        />
        <path
          d="M448.814 337.522C448.431 340.436 445.709 342.61 442.735 342.5L236.674 334.98C233.954 334.882 232.04 332.641 232.415 329.858L236.466 299.83C236.841 297.048 239.323 295.167 242.045 295.242L448.287 300.969C451.265 301.052 453.373 303.155 452.991 306.066L448.814 337.522Z"
          fill="white"
        />
        <path
          d="M440.836 398.535C440.452 401.455 437.728 403.947 434.755 403.798L228.849 393.627C226.131 393.492 224.24 390.891 224.615 388.105L228.698 357.497C229.072 354.714 231.578 352.327 234.297 352.437L440.329 360.747C443.302 360.868 445.406 363.558 445.022 366.474L440.836 398.535Z"
          fill="white"
        />
        <path
          opacity="0.1"
          d="M453.008 305.946C452.519 305.788 451.994 305.701 451.434 305.685L245.188 299.96C242.468 299.883 239.984 301.769 239.614 304.544L235.556 334.571C235.546 334.649 235.54 334.722 235.533 334.8C233.441 334.211 232.096 332.228 232.411 329.853L236.469 299.826C236.839 297.051 239.324 295.162 242.043 295.242L448.29 300.967C451.215 301.054 453.314 303.091 453.008 305.946Z"
          fill="url(#paint25_linear_1_7)"
        />
        <path
          opacity="0.1"
          d="M445.066 365.798C444.571 365.602 444.036 365.483 443.47 365.46L237.443 357.147C234.723 357.038 232.213 359.429 231.843 362.213L227.753 392.823C227.73 393.019 227.714 393.209 227.714 393.405C225.623 392.729 224.293 390.48 224.609 388.105L228.699 357.495C229.069 354.711 231.576 352.32 234.298 352.429L440.325 360.742C443.077 360.861 445.073 363.156 445.066 365.798Z"
          fill="url(#paint26_linear_1_7)"
        />
        <path
          d="M386.074 447.988C386.682 443.381 383.425 439.138 378.796 438.871L272.206 432.751C267.792 432.498 263.716 436.215 263.115 440.7L258.717 473.855C258.116 478.347 261.179 482.644 265.591 482.946L372.126 490.235C376.752 490.553 381.014 486.645 381.623 482.032L386.074 447.988Z"
          fill="url(#paint27_linear_1_7)"
        />
        <path
          d="M394.124 224.615C392.72 235.214 387.275 244.78 379.534 251.816C371.192 259.405 360.203 264.022 348.775 263.801C337.405 263.582 327.834 258.615 321.689 250.857C316.021 243.707 313.244 234.179 314.635 223.759C317.528 202.08 337.446 184.556 359.303 184.608C381.368 184.656 397.043 202.567 394.124 224.615Z"
          fill="url(#paint28_linear_1_7)"
        />
        <path
          d="M372.869 212.569C371.609 222.064 362.844 229.674 353.328 229.559C343.851 229.445 337.215 221.711 338.468 212.284C339.724 202.859 348.4 195.257 357.882 195.3C367.405 195.343 374.13 203.074 372.869 212.569Z"
          fill="white"
        />
        <path
          d="M379.535 251.816C371.193 259.405 360.204 264.022 348.777 263.801C337.407 263.582 327.836 258.615 321.69 250.857C328.724 241.058 340.325 234.54 352.645 234.7C365.032 234.86 375.016 241.725 379.535 251.816Z"
          fill="white"
        />
        <path
          opacity="0.4"
          d="M492.833 165.332L445.705 524.547C444.933 530.429 439.103 534.803 433.129 534.344L292.508 523.546C285.828 516.707 280.327 508.499 276.401 498.65C274.474 493.82 273.063 488.609 272.124 483.128C269.514 467.96 270.525 450.718 274.332 433.794C277.26 420.766 281.85 407.904 287.726 396.299C292.426 387.02 297.952 378.536 304.125 371.407C308.569 366.275 313.376 361.29 318.446 356.401C324.559 350.5 331.056 344.741 337.759 339.034C353.377 325.727 370.1 312.717 385.583 298.978C421.309 267.286 450.293 231.873 443.319 181.345C443.095 179.753 440.918 167.565 438.137 154.932L482.979 154.809C488.985 154.793 493.598 159.506 492.833 165.332Z"
          fill="#FDFDFD"
          fill-opacity="0.63"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1_7"
            x1="428.187"
            y1="461.786"
            x2="594.983"
            y2="11.3055"
            gradientUnits="userSpaceOnUse"
          >
            <stop
              offset="0.00359712"
              stop-color={props.primaryLight || "#E38D8D"}
            />
            <stop offset="1" stop-color={props.primaryColor || "#E41010"} />
          </linearGradient>
          <linearGradient
            id="paint1_linear_1_7"
            x1="304.712"
            y1="417.313"
            x2="628.243"
            y2="417.313"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color={props.primaryLight || "#FF8585"} />
            <stop offset="1" stop-color={props.primaryColor || "#FF7D7D"} />
          </linearGradient>
          <linearGradient
            id="paint2_linear_1_7"
            x1="387.738"
            y1="341.042"
            x2="483.236"
            y2="351.46"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#444B8C" />
            <stop offset="0.9964" stop-color="#26264F" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_1_7"
            x1="303.595"
            y1="100.32"
            x2="539.734"
            y2="904.237"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color={props.primaryLight || "#8C4444"} />
            <stop
              offset="0.9964"
              stop-color={props.primaryColor || "#D11818"}
            />
          </linearGradient>
          <linearGradient
            id="paint4_linear_1_7"
            x1="392.082"
            y1="80.5185"
            x2="669.609"
            y2="832.156"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFC444" />
            <stop offset="0.9964" stop-color="#F36F56" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_1_7"
            x1="-2032.59"
            y1="2171.85"
            x2="-1842.76"
            y2="1992.85"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#311944" />
            <stop offset="1" stop-color="#893976" />
          </linearGradient>
          <linearGradient
            id="paint6_linear_1_7"
            x1="23"
            y1="233"
            x2="188"
            y2="81.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color={props.primaryLight || "#DD4E40"} />
            <stop offset="1" stop-color={props.primaryColor || "#BD1C1C"} />
          </linearGradient>
          <linearGradient
            id="paint7_linear_1_7"
            x1="212.291"
            y1="317.167"
            x2="182.147"
            y2="347.849"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFC444" />
            <stop offset="0.9964" stop-color="#F36F56" />
          </linearGradient>
          <linearGradient
            id="paint8_linear_1_7"
            x1="137.572"
            y1="608.616"
            x2="137.826"
            y2="540.547"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#AA80F9" />
            <stop offset="0.9964" stop-color="#6165D7" />
          </linearGradient>
          <linearGradient
            id="paint9_linear_1_7"
            x1="130.83"
            y1="630.489"
            x2="127.589"
            y2="595.316"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFC444" />
            <stop offset="0.9964" stop-color="#F36F56" />
          </linearGradient>
          <linearGradient
            id="paint10_linear_1_7"
            x1="97.4417"
            y1="608.466"
            x2="97.6957"
            y2="540.397"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#AA80F9" />
            <stop offset="0.9964" stop-color="#6165D7" />
          </linearGradient>
          <linearGradient
            id="paint11_linear_1_7"
            x1="90.1584"
            y1="634.236"
            x2="86.9172"
            y2="599.063"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFC444" />
            <stop offset="0.9964" stop-color="#F36F56" />
          </linearGradient>
          <linearGradient
            id="paint12_linear_1_7"
            x1="128.599"
            y1="451.26"
            x2="103.649"
            y2="578.816"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#311944" />
            <stop offset="1" stop-color="#893976" />
          </linearGradient>
          <linearGradient
            id="paint13_linear_1_7"
            x1="142.05"
            y1="515.634"
            x2="104.565"
            y2="518.638"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#311944" />
            <stop offset="1" stop-color="#893976" />
          </linearGradient>
          <linearGradient
            id="paint14_linear_1_7"
            x1="121.317"
            y1="522.685"
            x2="64.4124"
            y2="527.246"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#311944" />
            <stop offset="1" stop-color="#893976" />
          </linearGradient>
          {/* Manche ko haat */}
          <linearGradient
            id="paint15_linear_1_7"
            x1="166.265"
            y1="334.867"
            x2="124.164"
            y2="605.246"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#F98080" />
            <stop offset="0.9964" stop-color="#D76161" />
          </linearGradient>
          {/* Manche ko chhaati */}
          <linearGradient
            id="paint16_linear_1_7"
            x1="76.7235"
            y1="631.647"
            x2="56.361"
            y2="904.525"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#F98080" />
            <stop offset="0.9964" stop-color="#D76161" />
          </linearGradient>
          <linearGradient
            id="paint17_linear_1_7"
            x1="7.49363"
            y1="538.606"
            x2="119.877"
            y2="346.102"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#F98080" />
            <stop offset="0.9964" stop-color="#D76161" />
          </linearGradient>
          <linearGradient
            id="paint18_linear_1_7"
            x1="47.3337"
            y1="405.504"
            x2="71.0362"
            y2="437.523"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFC444" />
            <stop offset="0.9964" stop-color="#F36F56" />
          </linearGradient>
          <linearGradient
            id="paint19_linear_1_7"
            x1="26.9739"
            y1="627.935"
            x2="6.61142"
            y2="900.814"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#F98080" />
            <stop offset="1" stop-color="#D76161" />
          </linearGradient>
          <linearGradient
            id="paint20_linear_1_7"
            x1="114.643"
            y1="325.717"
            x2="91.8249"
            y2="297.326"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFC444" />
            <stop offset="0.9964" stop-color="#F36F56" />
          </linearGradient>
          <linearGradient
            id="paint21_linear_1_7"
            x1="97.2924"
            y1="315.29"
            x2="109.386"
            y2="275.504"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#444B8C" />
            <stop offset="0.9964" stop-color="#3E4177" />
          </linearGradient>
          <linearGradient
            id="paint22_linear_1_7"
            x1="128.136"
            y1="301.406"
            x2="94.1182"
            y2="286.265"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFC444" />
            <stop offset="0.9964" stop-color="#F36F56" />
          </linearGradient>
          <linearGradient
            id="paint23_linear_1_7"
            x1="190.991"
            y1="348.376"
            x2="497.698"
            y2="348.376"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#311944" />
            <stop offset="1" stop-color="#893976" />
          </linearGradient>
          <linearGradient
            id="paint24_linear_1_7"
            x1="326"
            y1="650.5"
            x2="335.5"
            y2="180"
            gradientUnits="userSpaceOnUse"
          >
            <stop
              offset="0.003597"
              stop-color={props.primaryColor || "#8D0000"}
            />
            <stop offset="1" stop-color={props.primaryLight || "#FF003D"} />
          </linearGradient>
          <linearGradient
            id="paint25_linear_1_7"
            x1="232.364"
            y1="315.022"
            x2="453.036"
            y2="315.022"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.003597" stop-color="#F36F56" />
            <stop offset="1" stop-color="#FFC444" />
          </linearGradient>
          <linearGradient
            id="paint26_linear_1_7"
            x1="224.565"
            y1="372.916"
            x2="445.066"
            y2="372.916"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.003597" stop-color="#F36F56" />
            <stop offset="1" stop-color="#FFC444" />
          </linearGradient>
          <linearGradient
            id="paint27_linear_1_7"
            x1="332.946"
            y1="394.293"
            x2="283.654"
            y2="706.876"
            gradientUnits="userSpaceOnUse"
          >
            <stop
              offset="0.003597"
              stop-color={props.primaryColor || "#CF0E0E"}
            />
            <stop offset="1" stop-color={props.primaryLight || "#FF71CF"} />
          </linearGradient>
          <linearGradient
            id="paint28_linear_1_7"
            x1="349.16"
            y1="68.8361"
            x2="359.687"
            y2="382.31"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.003597" stop-color="#F36F56" />
            <stop offset="1" stop-color="#FFC444" />
          </linearGradient>
        </defs>
      </svg>
    </>
  );
}
